import { render, staticRenderFns } from "./MovementErrorModal.vue?vue&type=template&id=f60aaac6&"
import script from "./MovementErrorModal.vue?vue&type=script&lang=js&"
export * from "./MovementErrorModal.vue?vue&type=script&lang=js&"
import style0 from "./MovementErrorModal.vue?vue&type=style&index=0&id=f60aaac6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports